import React from 'react';
import { IOnlineMasteringPrice } from './interfaces';
import { YotpoReview } from '../../../../ui/rating/interfaces';
import OLPCreditCard from './olp-credit-card';

const firstList = ['1 Credit', '5 Credits', '15 Credits'];
const secondList = ['Standard', 'Pro'];

interface IOnlineMasteringPricesProps {
    prices: IOnlineMasteringPrice[];
    yotpoReviews: YotpoReview[];
}

const OnlineMasteringPrices = ({ prices, yotpoReviews }: IOnlineMasteringPricesProps) => {

    const firstListPrices = prices.filter(p => firstList.includes(p.marketingName));
    const secondListPrices = prices.filter(p => secondList.includes(p.marketingName));

    return (
        <div className="w-full mx-auto">
            <div className="flex flex-col">
                <div className="w-full order-1">

                    <div className="dv-grid w-full">
                        <div className="pricing-block-1 waves-box-lg mx-auto px-5 md:px-12 text-center text-xl">
                            <ul className="grid gap-12 grid-cols-1 md:grid-cols-2 lg:grid-cols-6 text-white">
                                {
                                    secondListPrices.map((om, i: number) => (
                                    <li
                                        key={om.skuid}
                                        className={`relative lg:col-span-2 ${ i === 0 ? 'lg:col-start-2' : 'lg:col-start-4' }`}>
                                        <OLPCreditCard om={ om } omType="subscribe" yotpoReviews={ yotpoReviews } />
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* One-Time Purchase always below */}
                <div className="w-full order-2">
                    <div className="pricing-block-2 waves-box-lg mx-auto px-5 md:px-12 text-center text-xl py-8 md:pt-12 md:pb-16">
                        <h4 className="text-2xl font-bold mb-4">Credit Packs</h4>
                        <p className="olm-accent-color text-lg">Buy credits as you go, no subscription needed</p>
                    </div>

                    <div className="dv-grid w-full">
                        <div className="waves-box-lg mx-auto px-5 md:px-12 text-center text-xl">
                            <ul className="grid gap-12 grid-cols-1 md:grid-cols-2 lg:grid-cols-6 text-white">
                                {
                                    firstListPrices.map((om) => (
                                        <li key={ om.skuid } className="relative lg:col-span-2">
                                            <OLPCreditCard om={ om } omType="one-time" yotpoReviews={ yotpoReviews } />
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    );
};

export default OnlineMasteringPrices;
